export {RouterContainer} from './RouterContainer';
export {RouterInstructionSchema} from './RouterDefinition';

import {Registry} from '@backstage-components/base';
import {RouterModule} from './RouterModule';
import {ComponentDefinition} from './RouterDefinition';
Registry.register(ComponentDefinition, RouterModule);
